import { useGetCreditApplicationById } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useAppStore } from '../../../data/AppContext'
import { getIdsFromUrl } from '../../../services/query-string'

export const useCurrentMerchantId = () => {
  const idsFromUrl = getIdsFromUrl()
  const appStore = useAppStore()
  const [creditApp] = useGetCreditApplicationById(idsFromUrl.creditAppId, EFinancingProgram.MechanicalWarranty, false)
  const merchantId = creditApp ? creditApp.merchantId : appStore.merchantId

  const parts = merchantId.split('*')
  return parts.length === 2 ? parts[1] : parts[0]
}
